<button class="btn" (click)="copy()">
  <svg
    stroke="currentColor"
    width="21"
    height="24"
    fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.26 9H9.794c-.917 0-1.66.895-1.66 2v9c0 1.105.743 2 1.66 2h7.466c.916 0 1.66-.895 1.66-2v-9c0-1.105-.744-2-1.66-2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.816 15h-.83c-.44 0-.862-.21-1.173-.586A2.226 2.226 0 012.327 13V4c0-.53.175-1.04.486-1.414C3.124 2.21 3.546 2 3.987 2h7.466c.44 0 .862.21 1.173.586.311.375.486.884.486 1.414v1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</button>
